import React, { useState, useContext } from 'react';
import { Form, Select, Row, Col, Input } from 'antd';
import { EditSerialNumberModal } from '../../../Modals/EditSerialNumberModal.component';
import { getDeviceTitle } from '../DevicesList/DevicesList.component';
import { DeviceForm } from '../DeviceForm.component';
import { Card } from '../../../../UI/Card/Card.component';
import { DeviceButtonGroup } from '../DeviceButtonGroup.component';
import { StationContext } from '../../../../../context/station-context';
import { Restricted } from '../../../../UI/Restricted.component';
import { DeviceRestrictedInput } from '../DeviceRestrictedInput.component';
import { PermissionsContext } from '../../../../../router/DashboardRoutes';
import { EditSerialNumButton } from '../EditSerialNumButton.component';

const { Option } = Select;
const { Item } = Form;

export const CAP = ({ device, anthemProfiles, isPanelPending, onSaveHandler, ...props }) => {

    const userPermissions = useContext(PermissionsContext);
    const allowEdit = userPermissions.device.edit;

    const [_, stationDispatch] = useContext(StationContext)
    const [form] = Form.useForm();
    const [displayModal, setDisplayModal] = useState(false);

    const valuesChangeHandler = (changedValues, allValues) => {
        Object.assign(allValues, {id: device.id, status: device.status, deviceType: device.deviceType});
        stationDispatch({
            type: 'ADD_PENDING_QUEUE', 
            payload: allValues,
        })
    }
    
    return (
        <>
            <div className='device__CAP'>
                <Row>
                    <Col flex={1}>
                        <DeviceForm
                            form={form}
                            name={`CAP-${device.id}-device-form`}
                            layout='vertical'
                            colon={false}
                            onValuesChange={(changedValues, allValues) => valuesChangeHandler(changedValues, allValues)}
                            initialValues={device}
                            onFinish={() => onSaveHandler([device.id])}
                        >
                        <Card bordered>
                            <div className='form__layout--vertical-inline'>
                                <EditSerialNumButton 
                                    serialNum={device.serialNum} 
                                    devicePending={isPanelPending(device)}
                                    onClick={() => setDisplayModal(true)}
                                />
                                <DeviceRestrictedInput label="Description:" name="comment">
                                    <Input />
                                </DeviceRestrictedInput>
                                <Restricted to='server.pci'>
                                    <Item label='Anthem Mode' name='anthemMode'>
                                        <Select>
                                            <Option value={true}>ON</Option>
                                            <Option value={false}>OFF</Option>
                                        </Select>
                                    </Item>
                                    <Item label='Anthem Profile:' name='anthemProfile'>
                                        <Select
                                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                            filterSort={(optionA, optionB) =>
                                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                }
                                            options={anthemProfiles?.map((profile) => ({
                                                label: `${profile.name} ${profile.value !== '0' ? `(${profile.value})` : '' }`, 
                                                value: profile.value, 
                                                key: profile.id,
                                                disabled: profile.disabled,
                                            }))}
                                            optionFilterProp='children'
                                            placeholder="Select Profile"
                                            showSearch
                                            />
                                    </Item>
                                </Restricted>
                                <DeviceRestrictedInput label='Version:' name='version' >
                                    <Input disabled/>
                                </DeviceRestrictedInput>
                            </div>
                            <Row justify='space-between' gutter={[12,12]}>
                                <DeviceButtonGroup serialNum={device.serialNum} status={device.status} ant winbox/>
                            </Row>
                        </Card>
                    </DeviceForm>
                </Col>
            </Row>
        </div>

        { displayModal && 
            <EditSerialNumberModal displayField={false} deviceType={getDeviceTitle(device.deviceType)} id={device.id} serialNum={device.serialNum} visible={displayModal} setVisible={setDisplayModal} />
        }
        </>
    );
}